import React, { useCallback, useContext, useEffect, useState } from "react";
import { Input, Table } from "antd";
import axios from "axios";
import { UserInfo } from "../../../context";
import MerchantLayout from "../../layout/MerchantLayout";

const MerchantInventory = () => {
  const [productRawList, setProductRawList] = useState({
    data: [],
    ready: false,
  });
  const tableLayout = "";
  const scroll = {};
  const { userData } = useContext(UserInfo);
  const [search, setSearch] = useState("");

  const tableProps = {
    bordered: false,
    size: "medium",
    showHeader: true,
    scroll,
    tableLayout,
  };

  const columns = [
    {
      title: "SKU",
      dataIndex: "sku",
      sorter: (a, b) => a.sku - b.sku,
      render: (text, record) => <p>{text}</p>,
    },
    {
      title: "Product",
      dataIndex: "product",
      render: (text, record) => <p>{text}</p>,
    },
    {
      title: "Description",
      dataIndex: "description",
      render: (text, record) => <p>{text}</p>,
    },
    {
      title: "Unit",
      dataIndex: ["rawproductsuserunit", "unit"],
      filters: [
        {
          text: "Piece(s)",
          value: "Piece(s)",
        },
        {
          text: "Bottle(s)",
          value: "Bottle(s)",
        },
        {
          text: "Vial(s)",
          value: "Vial(s)",
        },
        {
          text: "Box(s)",
          value: "Box(s)",
        },
      ],
      onFilter: (value, record) =>
        record.rawproductsuserunit.unit.includes(value),
      ellipsis: true,
      render: (text, record) => <p>{text}</p>,
    },
    {
      title: "MSRP",
      dataIndex: "msrp",
      align: "right",
      render: (text, record) => <p>{text}</p>,
    },
    {
      title: "SRP",
      dataIndex: "srp",
      align: "right",
      render: (text, record) => <p>{text}</p>,
    },
    {
      title: "Quantity",
      dataIndex: "quantity",
      align: "right",
      render: (text, record) => <p>{text}</p>,
    },
  ];

  const tableColumns = columns.map((item) => ({
    ...item,
    ellipsis: false,
  }));

  const getRawProductList = useCallback(() => {
    var params = { user_id: userData.data.id, is_production: "all" };
    axios
      .get("user/merchant/raw-product-list", {
        params,
      })
      .then((response) => {
        const data = response.data;
        setProductRawList({ data, ready: true });
      })
      .catch((error) => {
        console.log("ERROR: ", error);
      });
  }, [userData.data.id]);

  useEffect(() => {
    getRawProductList();
  }, [getRawProductList]);

  const searchable = productRawList.data.filter((data) => {
    return data.product.toLowerCase().indexOf(search.toLowerCase()) >= 0;
  });

  return (
    <MerchantLayout>
      <div style={{ overflowX: "auto" }}>
        <div style={{ marginBottom: 10 }}>
          <Input
            placeholder="Search raw"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            style={{
              border: "2px solid #e5e5e5",
              width: window.innerWidth < 576 ? "100%" : 300,
            }}
            size="large"
          />
        </div>
        <Table
          {...tableProps}
          pagination={{
            position: ["bottomCenter"],
          }}
          columns={tableColumns}
          dataSource={searchable.length > 0 ? searchable : []}
          scroll={scroll}
          rowKey={(record) => record.id}
        />
      </div>
    </MerchantLayout>
  );
};

export default MerchantInventory;
